// Use Growthbook from application.js bundle (window.growthbookClient) to avoid duplicating
function runBannerExperiment() {
  const gb = window.growthbookClient;
  if (!gb || !gb.isOn('exp_header_value-plans-banner_v1')) return;

  const closeBtn = document.getElementById("promo-banner-close");
  const signalPromoBanner = document.getElementById("promo-banner-signal");
  if (!closeBtn || !signalPromoBanner) return;

  closeBtn.onclick = function () {
    signalPromoBanner.classList.add("hidden");
  };
  signalPromoBanner.classList.remove("hidden");
}

function init() {
  if (window.growthbookClient) {
    runBannerExperiment();
  } else {
    window.addEventListener('growthbookReady', runBannerExperiment, { once: true });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
